/**
 * 이름 : fdpChartBar
 * 설명 : stacked bar chart
 * 최종 수정 일시 : 2019 - 04 - 01
 * 제공 :
 *  - reactiveProp :
 *     > chart.js 를 활용하는 부모에서 chart의 prop 변경 시, 동적으로 chart 변경 제공
 *  - event :
 *     > render 는 chart 랜더링 완료 후 호출
 *     > destroy 는 chart 컴포넌트 해제 후 호출
 *     > update 는 re-render 호출 시 호출
 */
import { object } from 'underscore'
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'sui-chart-stacked',
  extends: Bar,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    this.renderChart(this.chartData, Object.assign(this.options, 
        this.options.onClick = this.onClickChart
      ));
  },
  methods: {
    onClickChart(event, elements){
      if(elements.length <= 0) return;
      const curChart = this._data._chart;
      const curElement = curChart.getElementAtEvent(event)[0];
      const curIndex = curElement._index;
      const curDatasetIndex = curElement._datasetIndex;

      // const curLegend = curElement._model.datasetLabel;
      // const curXValue = curElement._model.label;
      const curLegend = curElement._chart.data.datasets[curDatasetIndex].label;
      const curXValue = curElement._chart.data.labels[curIndex];
      const curYValue = curElement._chart.data.datasets[curDatasetIndex].data[curIndex];

      if(curElement._chart.data.datasets[curDatasetIndex].type === 'line' ){
        console.log();
      }

      curElement.curLegend = curLegend; 
      curElement.curXValue = curXValue; 
      curElement.curYValue = curYValue; 

      console.log(curLegend, curXValue, curYValue, curIndex, curDatasetIndex);
      // console.log("datapoint:", datapoint, indexBar, indexSegment, curValue);
      this.$emit('barchartClicked', curElement);
    },
    updateChart(){
      console.log('stacked chaert')
      this.$data._chart.destroy() 
      this.renderChart(this.chartData, this.options)
    } 
  }
}
